import { Question, QuestionType, stateSelectorValues, CardPaymentPanel, CardInfo } from '@apply/ui';
import { PaymentApi } from '@apply/api';

type AddressSelectors = {
    name: string;
    phone: string;
    email: string;
    city: string;
    state: string;
    address1: string;
    address2: string;
};

export type PaymentInfoProps = {
    onQuestionValidate: (selector: string, passing: boolean, message: string) => void;
    onChangeBillingDetails: (newValue: string, propertyName: string) => void;
    onChangeBillingAddress: (newValue: string, propertyName: string) => void;
    submitted: boolean;
    billingDetails: PaymentApi.BillingDetails;
    addressSelectors: AddressSelectors;
    paymentError: string;
    cardInfo: CardInfo;
    set_cardInfo: React.Dispatch<React.SetStateAction<CardInfo>>;
};

export const PaymentInfo: React.FC<PaymentInfoProps> = ({
    onQuestionValidate,
    onChangeBillingDetails,
    onChangeBillingAddress,
    submitted,
    billingDetails,
    addressSelectors,
    paymentError,
    cardInfo,
    set_cardInfo,
}) => {
    const notSupportedCardType =
        cardInfo.cardType != 'VISA' && cardInfo.cardType != 'MASTERCARD' && cardInfo.cardType != undefined;

    return (
        <div className='row appraisal-section payment-info-section'>
            <div className='columns'>
                <div className='title'>Payment Info</div>
                <div className='payment-info-content'>
                    <Question
                        type={QuestionType.Text}
                        submitted={submitted}
                        selector={addressSelectors.name}
                        placeholder='John Q Smith'
                        styleName='ungrouped'
                        onQuestionValidate={onQuestionValidate}
                        value={billingDetails.name}
                        onChange={(newvalue: string) => onChangeBillingDetails(newvalue, 'name')}
                    >
                        Account Holder/Name on Card
                    </Question>
                    <Question
                        type={QuestionType.Phone}
                        submitted={submitted}
                        selector={addressSelectors.phone}
                        placeholder='(212) 555-1212'
                        styleName='ungrouped'
                        onQuestionValidate={onQuestionValidate}
                        value={billingDetails.phone}
                        onChange={(newvalue: string) => onChangeBillingDetails(newvalue, 'phone')}
                    >
                        Phone Number
                    </Question>
                    <Question
                        type={QuestionType.Email}
                        submitted={submitted}
                        selector={addressSelectors.email}
                        placeholder='jsmith@gmail.com'
                        styleName='ungrouped'
                        onQuestionValidate={onQuestionValidate}
                        value={billingDetails.email}
                        onChange={(newvalue: string) => onChangeBillingDetails(newvalue, 'email')}
                    >
                        Email Address
                    </Question>
                    <Question
                        type={QuestionType.Text}
                        submitted={submitted}
                        selector={addressSelectors.address1}
                        placeholder='123 Main Street'
                        styleName='grouped'
                        onQuestionValidate={onQuestionValidate}
                        value={billingDetails.address.line1}
                        onChange={(newvalue: string) => onChangeBillingAddress(newvalue, 'line1')}
                    >
                        <span className='sr-only'>Billing</span> Street Address
                    </Question>
                    <Question
                        type={QuestionType.Text}
                        submitted={submitted}
                        selector={addressSelectors.address2}
                        placeholder='Suite 123'
                        styleName='grouped'
                        value={billingDetails.address.line2}
                        onChange={(newvalue: string) => onChangeBillingAddress(newvalue, 'line2')}
                    >
                        <span className='sr-only'>Billing Street Address, Line 2</span>
                    </Question>
                    <div className='row city-state-row'>
                        <Question
                            type={QuestionType.Text}
                            submitted={submitted}
                            selector={addressSelectors.city}
                            placeholder='Hamilton'
                            styleName='grouped'
                            onQuestionValidate={onQuestionValidate}
                            value={billingDetails.address.city}
                            onChange={(newvalue: string) => onChangeBillingAddress(newvalue, 'city')}
                        >
                            <span className='sr-only'>Billing</span> City
                        </Question>
                        <Question
                            type={QuestionType.ColumnSelect}
                            selector={addressSelectors.state}
                            styleName='grouped'
                            submitted={submitted}
                            onQuestionValidate={onQuestionValidate}
                            value={billingDetails.address.state}
                            values={stateSelectorValues}
                            onChange={(newvalue: string) => onChangeBillingAddress(newvalue, 'state')}
                        >
                            <span className='sr-only'>Billing</span> State
                        </Question>
                    </div>
                    <CardPaymentPanel
                        cardInfo={cardInfo}
                        set_cardInfo={set_cardInfo}
                        disabled={false}
                    />
                    {notSupportedCardType && (
                        <div className='payment-error'>We apologize, we currently only support Visa and Mastercard.</div>
                    )}
                    {!!paymentError?.length && <div className='payment-error'>{paymentError}</div>}
                </div>
            </div>
        </div>
    );
};
